<template>
  <form id="id-tcc-transfer-form">
    <div v-if="loadingTransferPoints" class="p-4">Loading transfer points...</div>
    <div v-else class="form-group">
      <v-select :options="transferPoints" v-model="targetTransferPoint" placeholder="-- Select Transfer Points --">
        <template #search="{ attributes, events }">
          <input class="vs__search" v-bind="attributes" v-on="events" />
        </template>
      </v-select>
    </div>
    <div class="form-action bg-light px-3 py-3 d-flex flex-row-reverse">
      <button type="button" class="btn btn-info btn-rounded" @click="transferConversation" :disabled="httpPending">
        <i v-if="httpPending" class="fa fa-spinner fa-spin"></i>
        <span v-else>Transfer Conversation</span>
      </button>
    </div>
  </form>
</template>
  
<script>
import { mapGetters } from "vuex";
import VSelect from "vue-select";
import { EventBus } from "../../events/eventBus";

export default {
  name: "TransferConversationForm",
  components: { VSelect },
  props: {
    conversationId: String,
    sessionId: String
  },
  computed: {
    ...mapGetters("user", ["currentToken"]),
    ...mapGetters("agency", ["currentAgencyId"]),
    ...mapGetters("conversations", ["currentConversation"]),
  },
  data() {
    return {
      targetTransferPoint: null,
      transferPoints: null,
      httpPending: false,
      loadingTransferPoints: true
    };
  },
  methods: {
    async fetchTransferPoints() {
      const resp = await this.$ConveyApi.tccApi.getTccTransferPoints({ params: {} });
      this.transferPoints = resp.data.data.map(t => ({
        label: t.psap_name,
        value: t.psap_id,
        text: t.psap_name,
      }));
      this.loadingTransferPoints = false;
    },
    async transferConversation() {
      this.httpPending = true;
      try {
        await this.$ConveyApi.tccApi.transferTccSession({
          sessionId: this.sessionId,
          psapId: this.targetTransferPoint.value,
        });
        this.$toastr("success", `Transfer TCC Conversation on ${this.targetTransferPoint.label} Inititate`);
        this.httpPending = false;
        EventBus.$emit("close-modal");
      } catch (err) {
        console.error(`Error in transfer tcc conversation ${err}`);
        this.$toastr("error", "Error in transferring tcc conversation");
        this.httpPending = false;
        return false;
      }
    },
  },
  mounted() {
    this.fetchTransferPoints();
  },
};
</script>
  
<style lang="scss" scoped>
.form-action {
  margin-left: -1rem;
  margin-right: -1rem;
  margin-bottom: -1rem;
  border-radius: 0 0 5px 5px;
}
</style>